import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BottomSheetComponent } from "../../../../../shared/components/bottom-sheet/bottom-sheet.component";

export interface FilterCategory {
  id: string;
  label: string;
  route: string;
}

export interface FilterValue {
  id: string;
  label: string;
  selected: boolean;
}

export type FilterMode = "selection" | "configuration";

@Component({
  selector: "app-filter-panel",
  standalone: true,
  imports: [CommonModule, BottomSheetComponent],
  templateUrl: "./filter-panel.component.html",
  styleUrls: ["./filter-panel.component.scss"]
})
export class FilterDrawerComponent {
  @Input() isOpen: boolean = false;
  @Input() leftButtonText: string = "Clear All";
  @Input() rightButtonText: string = "Apply";
  @Input() FilterCategories: FilterCategory[] = [];
  @Input() selectedFiltersCount: number = 0;
  @Input() currentFilterType: string | null = null;
  @Input() filterValues: FilterValue[] = [];
  @Input() mode: FilterMode = "selection";
  @Input() selectedFiltersDisplay: {
    [key: string]: { id: string; label: string; type: string }[]
  } = {};
  @Input() shouldShowNoVendorsText: boolean = false;
  @Input() noVendorsText: string = "Trades will appear here once assigned to items";
  @Input() isSelectButtonDisabled: boolean = false;
  @Input() isApplyButtonDisabled: boolean = false;

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() leftButtonClick = new EventEmitter<void>();
  @Output() rightButtonClick = new EventEmitter<void>();
  @Output() closeIconClick = new EventEmitter<void>();
  @Output() FilterCategoryClick = new EventEmitter<FilterCategory>();
  @Output() filterValueToggle = new EventEmitter<FilterValue>();
  @Output() modeChange = new EventEmitter<{ mode: FilterMode; action: "select" | "cancel" }>();
  @Output() removeFilterPill = new EventEmitter<{ filterType: string; filterId: string }>();

  @ViewChild("filterHeaderTemplate", { static: true }) filterHeaderTemplate!: TemplateRef<unknown>;

  onFilterDrawerClose(): void {
    this.isOpenChange.emit(false);
  }

  onFilterClearAll(): void {
    this.leftButtonClick.emit();
  }

  onFilterApply(): void {
    this.rightButtonClick.emit();
  }

  onCloseIconClick(): void {
    this.closeIconClick.emit();
  }

  onFilterCategoryClick(option: FilterCategory): void {
    this.FilterCategoryClick.emit(option);
  }

  onFilterValueToggle(value: FilterValue): void {
    this.filterValueToggle.emit(value);
  }

  onCancel(): void {
    this.modeChange.emit({ mode: "selection", action: "cancel" });
  }

  onSelect(): void {
    this.modeChange.emit({ mode: "selection", action: "select" });
  }

  onRemoveFilterPill(filterType: string, filterId: string): void {
    this.removeFilterPill.emit({ filterType, filterId });
  }

}
